import React from 'react';
import { Bar } from 'react-chartjs-2';

const ScanAgingChart = ({ daycount, monthcount, notScan }) => {
    const maxValue = Math.max(daycount, monthcount, notScan);
    const maxY = Math.ceil(maxValue * 1.1);

    const data = {
        labels: ['0-7 Days', 'Last 6 Months', 'Not Scanning'],
        datasets: [
            {
                label: 'Scan Aging',
                data: [daycount, monthcount, notScan],
                backgroundColor: ['#4d79f6', '#28a745', '#17a2b8'],
                barThickness: 50,
                categoryPercentage: 0.5,
                barPercentage: 0.5,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: context => `${context.raw}%`,
                },
            },
            title: {
                display: false,
            },
            datalabels: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                max: maxY,
                ticks: {
                    callback: value => `${value}%`,
                    display: false,
                },
            },
            x: {
                grid: { display: false },
            },
        },
    };

    return (
        <div className='cdashboard_scan_box'>
            <Bar data={data} options={options} />
        </div>
    );
};

export default ScanAgingChart;
